import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./Vehicles'));

function LoadableVehicles() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableVehicles;
